import React from 'react';
import StatsHeader from './StatsHeader';

const View = ({ data }) => {
    return (
        <div>
        <StatsHeader data={data}/>
        </div>
    );
}

export default View;
